import React, { useState } from "react";
import {
  Header,
  Button,
  Paragraph
} from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";

import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import {
  applicationTypeFromLicenceSubType
} from "../../../redux/slice/applicationsUtils";
import "./ConfirmAIRSubmission.style.scss";
import CheckBoxForm from "../../../components/CheckBoxForm";
import { setMortgageProperty } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";
import { ERROR_STRING } from "../../../app/errors";

const MORTGAGE_APPLICATION_PROPERTY = "isAIRSubmitted";

export const ConfirmAIRSubmission = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;

  const [confirmAIRSubmitted, setConfirmAIRSubmitted] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const { agencyApplication } = useSelector(agencyApplicationSelector);

  const serverSaveRequest = useSelector(
    (state) => state.primaryAgencyApplication.serverRequestStatus
  );

  const dispatch = useDispatch();

  const handleContinue = () => {
    const update = {
      key: MORTGAGE_APPLICATION_PROPERTY,
      value: confirmAIRSubmitted
    };

    dispatch(setMortgageProperty(update));

    const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType);

    dispatch(saveBusinessLicenceApplicationData(applicationType, CONST.APPLICATION_MODE_RENEW))
      .then((data) => {
        if (isModal) {
          onEditSave();
        } else {
          let nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_TYPE_SUBMISSION}`;

          if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
            nextUrl = `${CONST.ROUTE_PATH.MA_APP}${CONST.ROUTE_PATH.RENEWAL_COMPANY_TYPE}`;
          } else if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
            nextUrl = `${CONST.ROUTE_PATH.ML_APP}${CONST.ROUTE_PATH.RENEWAL_COMPANY_TYPE}`;
          }

          dispatch(push(nextUrl));
        }
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });

    // if (isModal) {
    //   onEditSave();
    // } else {
    //   const applicationType = applicationTypeFromLicenceSubType(agencyApplication.licencingSubType);

    //   let nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_COMPANY_TYPE_SUBMISSION}`;

    //   if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
    //     nextUrl = `${CONST.ROUTE_PATH.MA_APP}${CONST.ROUTE_PATH.RENEWAL_COMPANY_TYPE}`;
    //   } else if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
    //     nextUrl = `${CONST.ROUTE_PATH.ML_APP}${CONST.ROUTE_PATH.RENEWAL_COMPANY_TYPE}`;
    //   }
    //   dispatch(push(nextUrl));
    // }
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && <TopNavigationBar {...props} />}

      <div className="row">
        {!isModal && (
          <div className="col-xs-12 col-lg-11">
            <Header id="mra-renewal-confirm-air-header" header="Annual Information Return (AIR)" />
          </div>
        )}
        <div className="col-xs-12 col-lg-11 topMarginMedium">
          <Paragraph
            id="mra-renewal-confirm-air-text-1"
            style={{ fontWeight: "bold", fontSize: "1.2em" }}
            text={[
              "An Annual Information Return (AIR) is required for licence renewal. For the current renewal, you will receive a separate email from our compliance team about the AIR."
            ]}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 col-lg-9">
          <CheckBoxForm
            id="confirm-air-submission-checkbox"
            checked={confirmAIRSubmitted}
            value={confirmAIRSubmitted}
            labelText="Have you submitted your Annual Information Return?"
            onCheckBoxChange={(val) => {
              setConfirmAIRSubmitted(val);
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className={"col-lg-8"}>
          <div className="col-xs-3">
            <Button
              className="btn-lg btn-default"
              buttonType={"regular_primary"}
              text={!isModal ? "Continue" : "Save and close"}
              showSpinner={serverSaveRequest === CONST.REQUEST_STATUS.IN_PROGRESS}
              disabled={serverSaveRequest === CONST.REQUEST_STATUS.IN_PROGRESS}
              onClick={handleContinue}
            />
          </div>
        </div>
      </div>
      {applicationSaveError && (
        <div className="ns-error-message help-block topMarginNormal">
          <span className="ns-visually-hidden">Error:</span>
          {ERROR_STRING.APPLICATION_SAVE_ERROR}
        </div>
      )}
    </div>
  );
};
